<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm
            v-if="!displayPreview"
            :key="appFormKey"
            :vo-name="isEdit ? 'BlogGetVo' : 'BlogAddVo'"
            :data="tmpBlog" 
            @changed="onFormChange"
          />
          <PageRender
            v-if="displayPreview"
            v-show="tmpBlog.title"
            :id="tmpSectionBuilder.id"
            :sections="[tmpSectionBuilder,]"
            :global-style="this.defaultGlobalStyles"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton 
            @click="displayPreview = !displayPreview"
            :text="displayPreview ? i18nMessage.Edit : i18nMessage.Preview"
            color="dark"
          />
          &nbsp;
          <LoadingStateButton
            v-if="displayPreview"
            @click="onAddOrUpdateBlog"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateBlogLoading"
          />
          <template v-if="isEdit">
            &nbsp;
            <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
          </template>
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
    <CModal
      :show.sync="showDeleteModal"
      :centered="true"
      color="default"
    >
      {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{blog.title}}</b>
      <br/><br/>
      <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== blog.title"
          @click="onDeleteBlog"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deleteBlogLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'
import PageRender from '../../page-lib/components/PageRender'
import yaml from "js-yaml";

export default {
  name: 'Blog',
  components: {
    AppForm,
    LoadingStateButton,
    PageRender,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpBlog: {},
      updateBlogLoading: false,
      deleteBlogLoading: false,
      appFormKey: generateGUID(),
      displayPreview: false,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      sectionBuilder: state => state.pageBuilder.sectionBuilder,
      blog: state => state.blog.blog,
      defaultGlobalStyles: state => state.defaultGlobalStyles,
    }),
    tmpSectionBuilder() {
      const sectionBuilder = {
        ...this.sectionBuilder
      }

      const staticData = yaml.load(this.sectionBuilder.static_data)

      sectionBuilder.static_data = yaml.dump({
        data: {
          ...staticData.data,
          GetBlogByTitle: {
            title: this.tmpBlog.title,
            image_url: this.tmpBlog.image_url,
            content: this.tmpBlog.content,
            updated_at: this.tmpBlog.updated_at ? this.tmpBlog.updated_at : new Date().toISOString(),
          },
        }
      })
    
      return sectionBuilder
    },
  },
  methods: {
    ...mapActions({
      getBlog: 'blog/getBlog',
      updateBlog: 'blog/updateBlog',
      addBlog: 'blog/addBlog',
      deleteBlog: 'blog/deleteBlog',
      getSectionBuilderByName: 'pageBuilder/getSectionBuilderByName',
    }),
    ...mapMutations({
      setBlog: 'blog/setBlog',
      setSectionBuilder: 'pageBuilder/setSectionBuilder',
    }),
    goBack() {
      this.$router.push({path: '/blog'})
    },
    onFormChange (data) {
      this.tmpBlog = {...data}
    },
    onAddOrUpdateBlog () {
      if (this.tmpBlog.id) {
        this.updateBlogLoading = true
        this.updateBlog(this.tmpBlog)
          .then(() => {
            this.updateBlogLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateBlogLoading = false
          })
      } else {
        this.updateBlogLoading = true
        this.addBlog(this.tmpBlog)
          .then(() => {
            this.updateBlogLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateBlogLoading = false
          })
      }
    },
    onDeleteBlog () {
      this.deleteBlogLoading = true
      this.deleteBlog(this.blog.id)
          .then(() => {
            this.deleteBlogLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteBlogLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    this.getSectionBuilderByName('BlogTemplate')
    if (this.isEdit) {
      this.getBlog(this.$route.params.id).then(() => {
        this.tmpBlog = this.blog
      })
    }
  },
  destroyed() {
    this.setSectionBuilder({})
    this.setBlog({})
  }
}
</script>

<style>
  .section-modal.overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(51,51,51,0.7);
    z-index: 10;
  }

  .section-modal > .modal-header {
    padding: 5px;
  }

  .section-modal > .modal-content {
    overflow: hidden;
  }

  .section-modal > .modal-body {
    overflow-y: scroll;
    padding: 0px;
  }

  .section-modal > .modal-footer {
    display: none;
  }
</style>